"use client";

import { c as _c } from "react/compiler-runtime";
import React, { ReactNode } from "react";
import Countdown from "react-countdown";
import { useTranslations } from "next-intl";
import IOtpInput from "@/app/components/Common/Input/IOtpInput";
import { CountdownIcon } from "@/app/components/UI/Icons";
import cn from "@/app/utils/cn";
import Button from "@/app/components/UI/Button";
interface VerificationCodeProps {
  inputLabel: ReactNode;
  helperText?: ReactNode;
  value: string;
  onChange: (value: string) => void;
  error?: {
    hasError?: boolean;
    message?: string;
  };
  timer?: {
    visible?: boolean;
    target?: number | null;
    completed?: boolean;
    onComplete?: () => void;
    onResend?: (event: React.MouseEvent) => void;
  };
  inputClassName?: string;
  secondaryAction?: {
    label: ReactNode;
    onClick: () => void;
    disabled?: boolean;
  };
}
export default function VerificationCode(t0) {
  const $ = _c(27);
  const {
    inputLabel,
    helperText,
    value,
    onChange,
    error,
    timer,
    inputClassName,
    secondaryAction
  } = t0;
  const t = useTranslations();
  let t1;
  if ($[0] !== inputLabel) {
    t1 = <p className="text-sm text-charcoal-900 font-semibold mb-1 text-start">{inputLabel}</p>;
    $[0] = inputLabel;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== helperText) {
    t2 = helperText && <div className="text-charcoal-600 text-sm md:text-base text-start">{helperText}</div>;
    $[2] = helperText;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="mb-3">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = error?.hasError ? "!border-red-500" : "";
  let t5;
  if ($[7] !== inputClassName || $[8] !== t4) {
    t5 = cn(t4, inputClassName);
    $[7] = inputClassName;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== onChange || $[11] !== t5 || $[12] !== value) {
    t6 = <div className="max-w-full" dir="ltr"><IOtpInput inputValue={value} inputOnchange={onChange} setOtpCode={onChange} customStyle={t5} /></div>;
    $[10] = onChange;
    $[11] = t5;
    $[12] = value;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== error) {
    t7 = error?.message && <p className="text-xs text-rojo-400 text-start pt-2">{error.message}</p>;
    $[14] = error;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t || $[17] !== timer) {
    t8 = timer?.visible && <div className="flex justify-start mt-4">{timer.completed ? <button type="button" onClick={timer.onResend} className="cursor-pointer bg-bluetiful-400 text-xs font-semibold text-bluetiful-50 px-3 py-2 rounded-xl">{t("auth.RESEND_CODE")}</button> : <span className="inline-flex items-center gap-x-1 text-bluetiful-400 text-xs font-semibold bg-bluetiful-50 px-3 py-2 rounded-xl"><CountdownIcon className="w-6 h-6" />{t("auth.CODE_VALID_UNTIL")}{timer.target && <Countdown date={timer.target} className="me-2" onComplete={timer.onComplete} renderer={_temp} />}{t("auth.CODE_VALID_SUFFIX")}</span>}</div>;
    $[16] = t;
    $[17] = timer;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== secondaryAction) {
    t9 = secondaryAction && <Button variant="ghost" color="primary" size="sm" onClick={secondaryAction.onClick} disabled={secondaryAction.disabled} className="mt-4">{secondaryAction.label}</Button>;
    $[19] = secondaryAction;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t3 || $[22] !== t6 || $[23] !== t7 || $[24] !== t8 || $[25] !== t9) {
    t10 = <>{t3}{t6}{t7}{t8}{t9}</>;
    $[21] = t3;
    $[22] = t6;
    $[23] = t7;
    $[24] = t8;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  return t10;
}
function _temp(t0) {
  const {
    minutes,
    seconds
  } = t0;
  return <span>{minutes}:{seconds < 10 ? `0${seconds}` : seconds}</span>;
}